/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

//vmask
import VueMask from 'v-mask'
Vue.use(VueMask)

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)

//Session
import VueSession from 'vue-session'
Vue.use(VueSession)

//i18n
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

// i18n
import i18n from './i18n/i18n'

//days
import * as dayjs from 'dayjs'
import * as relativeTimePlugin from 'dayjs/plugin/relativeTime'
import * as duration from 'dayjs/plugin/duration'
require('dayjs/locale/es')
require('dayjs/locale/en')
dayjs.locale(i18n.locale)
dayjs.extend(relativeTimePlugin)
dayjs.extend(duration)
Vue.prototype.$dayjs = dayjs 

// axios
import axios from './axios.js'
Vue.prototype.$http = axios

// Filters
import './filters/filters.js'


// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';


Vue.config.productionTip = false

export const app = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
